import { createContext, useContext } from "react"
import { IVitalView } from "@/types/vitals.types"

const EMPTY_VITALS: IVitalView[] = []

export const HeroVitalsContext = createContext<IVitalView[]>(EMPTY_VITALS)

export const useHeroVitalsContext = (): IVitalView[] =>
  useContext(HeroVitalsContext)
